const getFileExtension = (filename = "") => {
  const fileExtension =
    filename.substring(filename.lastIndexOf(".") + 1, filename.length) ||
    filename

  return fileExtension.toLocaleLowerCase()
}

export default getFileExtension
